var map = {
	"./censoautomotriz.png": 3273,
	"./ikco.png": 7393,
	"./ikco_.png": 1070,
	"./logoDena.png": 8751,
	"./logoQuik.png": 1703,
	"./logoSaina.png": 7440,
	"./logoTara.png": 4180,
	"./mision-transporte.png": 4898,
	"./saipa.png": 3032,
	"./saipa_.png": 4213,
	"./veniran.png": 1375,
	"./veniran_.png": 5506
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;